import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentService, licenseKey } from '@sia/shared';
import { format } from 'date-fns';
import config from 'devextreme/core/config';
import moment from 'moment';
import 'moment/locale/it';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  styles: [],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent {
  private environmentService = inject(EnvironmentService);

  constructor() {
    this.environmentService.environment = environment;
    config({
      licenseKey: licenseKey,
    });

    Date.prototype.toJSON = function () {
      if (isNaN(this.getTime())) {
        return '';
      }
      return format(this, "yyyy-MM-dd'T'HH:mm:ss");
    };

    Date.prototype.toISOString = function () {
      return format(this, "yyyy-MM-dd'T'HH:mm:ss");
    };

    moment.locale('it');
  }
}
